<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useCartStore } from '@/stores/cart';

const { qtTotal } = storeToRefs(useCartStore());

const props = defineProps({
    title: String,
    to: [String, Object],
    show: Boolean
})

</script>
<template>
    <router-link :to="to">
        <div>
            <span class="cart_num" v-if="qtTotal>0">{{qtTotal}}</span>
            <img src="../../assets/icons/cart.svg" :alt="title" />
        </div>
        <span class="title" v-if="show">{{title}}</span>
    </router-link>
</template>

<style lang="scss" scoped>
a{
    position: relative;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    margin: 0 8px;
    justify-content: center;
    text-align: center;
    height: 58px;
    color: #FFF;
    font-size: 14px;
    line-height: 17px;
    height: auto;
    &>div{
        position: relative;
        img{
            height: 21px;
            margin-bottom: 7px;
        }
        span.cart_num{
            position: absolute;
            top: -9px;
            left: calc(50% + 3px);
            background-color: #E91B1B;
            padding: 0 2px;
            min-width: 11px;
            border-radius: 11px;
            color: #FFF;
            font-size: 10px;
            line-height: 12px;
            text-align: center;
            display: block;
        }
    }
    
    span.title{
        display: inline-block;
        background-color: #5EC5FF;
        border-radius: 12px;
        padding: 0 7px;
    }
}
</style>